// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import cx from 'classnames';
import Dialog from '../../shared/dialog';

export default class LocationEntry extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = this.locationStateFromProps(props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.show) {
      this.setState(this.locationStateFromProps(nextProps));
    }
  }

  render() {
    const { styles } = LocationEntry;

    return (
      <Dialog
        show={this.props.show}
        title="Enter Location"
        positive="Done"
        width={300}
        onNegativeClick={this.handleNegativeClick}
        onPositiveClick={this.handlePositiveClick}
      >
        <div className={css(styles.container)}>
          <div>
            <input
              type="text"
              className={css(styles.input)}
              value={this.state.latitude}
              onChange={this.handleLatitudeChange}
              placeholder="Latitude"
              onPaste={this.handlePaste}
            />
          </div>
          <div>
            <input
              type="text"
              className={css(styles.input)}
              value={this.state.longitude}
              onChange={this.handleLongitudeChange}
              placeholder="Longitude"
            />
          </div>
        </div>
      </Dialog>
    );
  }

  locationStateFromProps(props) {
    return {
      latitude: props.feature.latitude != null ? props.feature.latitude.toString() : '',
      longitude: props.feature.longitude != null ? props.feature.longitude.toString() : '',
    };
  }

  handlePaste = (event) => {
    const location = event.clipboardData.getData('Text').trim().split(/\s|,/);

    if (location.length > 1) {
      let [lat, lon] = location.filter((x) => x);

      lat = +lat.trim();
      lon = +lon.trim();

      if (!isNaN(lat) && !isNaN(lon)) {
        this.setState({ latitude: lat, longitude: lon });
        event.preventDefault();
      }
    }
  };

  handleLatitudeChange = (event) => {
    const { value } = event.target;
    this.setState({ latitude: value });
  };

  handleLongitudeChange = (event) => {
    const { value } = event.target;
    this.setState({ longitude: value });
  };

  handleNegativeClick = (event) => {
    this.props.onCancel();
  };

  handlePositiveClick = (event) => {
    this.props.onDone(this.coordinate);
  };

  get coordinate() {
    let latitude = +this.state.latitude;
    let longitude = +this.state.longitude;

    if (latitude == null || isNaN(latitude) || latitude > 90 || latitude < -90) {
      latitude = null;
    }

    if (longitude == null || isNaN(longitude) || longitude > 180 || longitude < -180) {
      longitude = null;
    }

    if (latitude == null || longitude == null) {
      latitude = null;
      longitude = null;
    }

    if (latitude != null && longitude != null) {
      return {
        latitude,
        longitude,
      };
    }

    return null;
  }
}

const styles = cssInJS({
  input: {
    marginTop: 4,
    padding: 4,
    width: 240,
    border: '1px solid #ccc',
    WebkitAppearance: 'none',
    borderRadius: 5,
    height: 25,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,
  },
});

LocationEntry.styles = styles;
